import * as React from 'react';
import {Create, TextInput, required, SimpleForm, SelectInput, ReferenceInput} from 'react-admin';
import {STATUSES} from "../../common/constants";
import SlugInput from '../../common/inputs/SlugInput';


const IssueTopicCreate = () => (
    <Create redirect={'/issue-topics'}>
        <SimpleForm>
            <TextInput source="name" fullWidth validate={[required()]}/>
            <SlugInput source="slug" fullWidth/>
            <SelectInput
                source="status"
                label={'Status'}
                fullWidth
                validate={[required()]}
                choices={STATUSES}
            />
        </SimpleForm>
    </Create>
);

export default IssueTopicCreate;
